import { GradientMesh, PageTransition } from '@merritrac/shared/components';
import { Outlet, useLocation } from 'react-router';

import { Header } from './Header.js';
import { Sidebar } from './Sidebar.js';

import type { ReactElement } from 'react';

const ROUTE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/service-orders': 'Service Orders',
  '/clients': 'Clients',
  '/units': 'Units',
  '/checklists': 'Checklists',
  '/time-tracking': 'Time Tracking',
  '/users': 'Users',
  '/settings': 'Settings',
};

export function AppLayout(): ReactElement {
  const location = useLocation();
  const title = ROUTE_TITLES[location.pathname] ?? 'MerriTrac';

  return (
    <div className="min-h-screen relative">
      <GradientMesh />
      <Sidebar />
      <div className="ml-[var(--sidebar-w)] flex flex-col min-h-screen relative z-10">
        <Header title={title} />
        <main className="flex-1 p-6">
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </main>
      </div>
    </div>
  );
}
